import { CreateOfferAsyncActions } from 'store/actions/createOffer';
import { createReducerFromActions } from 'utils/store';
import { values } from 'lodash';

export default createReducerFromActions(...values(CreateOfferAsyncActions));
